import React from "react";
import Aside from "./Aside.js";
import { Route } from "react-router-dom";
import Dashboard from "./../DashBoard/main";
import Settings from "./../Settings/main.js";
// import Client from "./../Client/main.js";
// import ClientCreate from "./../Client/Create";
// import ClientDetails from "./../Client/OneClient";
import TopBar from "./TopBar";
import Providers from './../Provider/main.js'
import ProviderDetails from './../Provider/OneProvider'
import CodeBook from './../CodeBook/main.js'
import Import from './../Import/main.js'
import Transaction from './../Transaction/main.js'

function Layout(props) {
    return (
        <>       
            <TopBar />
            <div className={`app`}>

                <Aside />

                <Route  path="/dashboard" component={Dashboard} />

                <Route path="/settings" component={Settings} />

                {props.roles.indexOf("POWERADMIN") > -1 ?
                <>
                    <Route exact path="/providers" component={Providers} />                        

                    <Route exact path="/providers/:id" component={ProviderDetails} />

                    <Route path="/codeBook">
                        <CodeBook />
                    </Route>

                    <Route path="/import">
                        <Import />
                    </Route>

                    <Route path="/transaction">
                        <Transaction />
                    </Route>
                </>
                :null}
            </div>
        </>
    );
}

export default Layout;
